<ion-header translucent="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" text="{{ 'COMMON.BACK' | translate }}" />
    </ion-buttons>
    <ion-buttons slot="end">
      <div class="flex">
        <mtjr-heart-button [productId]="productId" class="me-1" />
        <ion-button class="me-1" (click)="openShareOptions(productId)">
          <ion-icon name="share-social-outline" slot="icon-only"></ion-icon>
        </ion-button>
        <div class="relative">
          <ion-button routerLink="/cart">
            <ion-icon name="cart" slot="icon-only"></ion-icon>
            @if (cartStore.totalCount() > 0) {
              <div
                slot="end"
                class="bg-danger absolute start-0 top-0 flex h-4 min-w-4 items-center justify-center rounded-full p-1 text-center text-xs text-white"
              >
                <span>{{ cartStore.totalCount() }}</span>
              </div>
            }
          </ion-button>
        </div>
      </div>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="bg-surface scroll-visible" fullscreen="true">
  <div class="flex items-center justify-center md:mt-5">
    <div class="flex w-full max-w-full flex-col md:max-w-[650px]">
      <div class="w-max-mid w-full">
        @if (store.dynamicInfo(); as info) {
          <mtjr-product-swiper
            [blurHash]="info.blurHash"
            [images]="info.images"
            [isVoucherVendor]="store.isVoucherVendor()"
          />
        }
      </div>

      <div class="flex-grow">
        @if (store.product(); as product) {
          <div class="ms-4 mt-3 flex flex-col">
            <div class="flex">
              <ion-text class="flex-1 text-xl font-bold">{{ product.name }}</ion-text>
              <ion-text color="warning" class="me-3 text-lg font-bold">
                {{ store.selectedVariation()?.price ?? store.dynamicInfo().price | vxCurrency }}
              </ion-text>
            </div>
            <div class="bg-medium/10 my-2 h-[1px] w-full"></div>
            <div class="flex cursor-pointer items-center" routerLink="reviews">
              <ion-icon name="star-circle" class="me-1.5 text-xl" color="success" />
              <ion-text color="medium" class="flex-1">
                <span class="me-1">{{ product.ratingAvg | number: "1.1-1" }}</span>
                <span>( {{ product.ratingCount }} {{ "PRODUCTS.REVIEWS" | translate }} )</span>
              </ion-text>
            </div>

            @if (product.description) {
              <ion-text class="mt-2 text-xl">{{ "PRODUCTS.DESCRIPTION" | translate }}</ion-text>
              <ion-text class="me-3 mt-1 select-none" color="medium">{{ product.description }}</ion-text>
            }
          </div>
          @if (store.attributes().length > 0) {
            <mtjr-product-attributes-section
              [attributes]="store.attributes()"
              [selectedAttributes]="store.selectedAttributes()"
              [availableAttributes]="store.availableAttributes()"
              [productBgColor]="product.bgColor"
              [isVoucherVendor]="store.isVoucherVendor()"
              (attributeToggle)="onAttributeToggle($event)"
            />
          }

          <mtjr-product-reviews-section [productId]="product.id" />

          @switch (relatedProductsStore.relatedProductsListState().type) {
            @case ("loading") {
              <mtjr-loading></mtjr-loading>
            }
            @case ("error") {
              <mtjr-error [failure]="relatedProductsStore.relatedProductsFailure()"></mtjr-error>
            }
            @case ("success") {
              <div class="flex w-full flex-col p-4">
                <div class="bg-medium/10 mb-3 h-[1px] w-full"></div>
                <ion-text class="mx-1">{{ "PRODUCTS.RELATED_PRODUCTS" | translate }}</ion-text>
                <div class="mt-3 grid w-full grid-cols-2 gap-3 sm:grid-cols-3">
                  @for (product of relatedProductsStore.relatedProducts(); track $index) {
                    <mtjr-product-card [product]="product" baseLink="../../" />
                  }
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  </div>
</ion-content>
<ion-footer id="footer">
  <div class="bg-primary flex h-16 items-center justify-center dark:bg-slate-900">
    @if (store.dynamicInfo().stock > 0) {
      <ion-text color="dark me-2 text-light/80 dark:text-dark/80">
        {{ "PRODUCTS.PRICE" | translate }}
        <span class="text-light dark:text-dark text-xl font-bold">
          {{ store.selectedVariation()?.price ?? store.dynamicInfo().price | vxCurrency }}
        </span>
      </ion-text>
    }
    @if (store.product()?.type !== "digital") {
      <ion-button
        expand="block"
        shape="round"
        class="mx-2"
        color="light"
        (click)="addToCart()"
        [disabled]="store.dynamicInfo().stock <= 0"
      >
        <ion-text class="capitalize">
          {{
            store.dynamicInfo().stock > 0
              ? ("PRODUCTS.ADD_TO_CART" | translate)
              : ("PRODUCTS.NOT_AVAILABLE" | translate)
          }}
        </ion-text>

        <ion-icon slot="start" name="cart" />
      </ion-button>
    } @else {
      <ion-button
        expand="block"
        shape="round"
        class="mx-2"
        color="light"
        (click)="buyNow()"
        [disabled]="store.dynamicInfo().stock <= 0"
      >
        <ion-text class="capitalize">
          {{
            store.dynamicInfo().stock > 0 ? ("PRODUCTS.BUY_NOW" | translate) : ("PRODUCTS.NOT_AVAILABLE" | translate)
          }}
        </ion-text>
        <ion-icon slot="start" name="cart" />
      </ion-button>
    }
  </div>
</ion-footer>

<ion-modal
  [isOpen]="buyNowModalArgs() !== undefined"
  (willDismiss)="buyNowModalArgs.set(undefined)"
  cssClass="rounded-dialog"
  [breakpoints]="[0.0, 0.55]"
  [initialBreakpoint]="0.55"
>
  <ng-template>
    <ion-header [translucent]="true">
      <ion-toolbar>
        <ion-title>{{ "PRODUCTS.BUY_NOW" | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button fill="clear" (click)="buyNowModalArgs.set(undefined)">
            <ion-icon name="close" />
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="bg-surface ion-padding">
      @if (buyNowModalArgs(); as args) {
        <div class="flex items-center px-3 py-2">
          <mtjr-img
            proxy="https://dev-img.mtjr.ly/unsafe/resize:auto:1280:720/sm:1/q:85/plain/"
            [src]="args.product.images?.[0] || args.variation.image"
            [imgClass]="
              'w-16 aspect-square rounded-xl p-[0.2px] border border-solid border-medium/30 me-2 ' +
              (store.isVoucherVendor() ? 'object-contain' : 'object-cover')
            "
            alt="thumbnail"
            [disabled]="store.isVoucherVendor()"
          />
          <div class="ms-2 flex flex-col">
            <ion-text class="mb-2 pe-4 font-bold">{{ args.product.name }}</ion-text>
            @for (attr of args.variation.attributes; track $index) {
              @if (attr.type !== "color") {
                <div class="border-primary text-primary bg-primary/10 min-w-6 rounded-md px-2 py-1 text-center">
                  {{ attr.label }} - {{ "COMMON.CURRENCY_SYMBOL" | translate }}
                </div>
              } @else {
                <div
                  fill="clear"
                  class="border-medium !m-0 flex size-6 items-center justify-center rounded-full border-2 border-solid !p-0 text-white"
                  [ngStyle]="{
                    'background-color': attr.key,
                  }"
                ></div>
              }
            }
          </div>
        </div>
        <ion-item lines="none">
          <ion-label class="text-primary">
            <div class="flex flex-col">
              <span class="text-dark">{{ "WALLET.BALANCE" | translate }}</span>
              <ion-text class="text-success mt-2 font-bold">
                {{ walletStore.walletBalance() | quarterFloor | vxCurrency }}
              </ion-text>
            </div>
          </ion-label>

          <ion-button fill="clear" class="text-primary" (click)="topUpWallet()">
            <ion-icon name="wallet" slot="end" />
            <ion-text>{{ "WALLET.TOP_UP" | translate }}</ion-text>
          </ion-button>
        </ion-item>

        <div class="bg-primary/5 mx-4 mb-4 rounded-xl px-4 py-4">
          <ion-text class="font-bold">{{ "CHECKOUT.ORDER_SUMMARY" | translate }}</ion-text>

          <div class="bg-medium/5 mb-2 mt-3 h-[2px] w-full"></div>
          <div class="mt-2 flex items-center">
            <ion-text class="text-medium text-sm">{{ "CHECKOUT.TOTAL" | translate }}</ion-text>
            <div class="flex-grow"></div>
            <ion-text class="text-md text-primary font-bold">
              {{ args.variation.price | vxCurrency }}
            </ion-text>
          </div>
        </div>
        <div class="px-4 py-1">
          <mtjr-error-bar [failure]="buyNowStore.buyNowFailure()" />
        </div>

        <div class="mx-3">
          <mtjr-submit-button
            [state]="buyNowStore.buyNowState()"
            [label]="'PRODUCTS.CONFIRM_BUY_NOW' | translate"
            (click)="confirmBuyNow(args)"
            [disabled]="args.variation.price > walletStore.walletBalance().toNumber()"
          />
        </div>
      }
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal
  [isOpen]="shareModalOpen()"
  (willDismiss)="shareModalOpen.set(false)"
  cssClass="rounded-dialog"
  [breakpoints]="[0.0, 0.35]"
  [initialBreakpoint]="0.35"
>
  <ng-template>
    <ion-header [translucent]="true">
      <ion-toolbar>
        <ion-title>{{ "COMMON.SHARE" | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button fill="clear" (click)="shareModalOpen.set(false)">
            <ion-text>
              {{ "COMMON.CANCEL" | translate }}
            </ion-text>
            <ion-icon slot="end" name="close" />
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="bg-surface ion-padding">
      <div class="flex flex-col items-center">
        <div class="grid grid-cols-3 gap-5 w-full">
          <!-- copy -->
          <div class="flex flex-col items-center gap-1" (click)="copyToClipboard(currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-dark mb-1 cursor-pointer">
              <ion-icon name="copy-outline" class="text-2xl text-gray-700"></ion-icon>
            </div>
            <ion-text class="text-xs">{{ "COMMON.COPY_LINK" | translate }}</ion-text>
          </div>

          <!-- Facebook -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('facebook', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 mb-1 cursor-pointer">
              <ion-icon name="logo-facebook" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">Facebook</ion-text>
          </div>

          <!-- Twitter/X -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('twitter', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-black mb-1 cursor-pointer">
              <ion-icon name="logo-twitter" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">X</ion-text>
          </div>

          <!-- WhatsApp -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('whatsapp', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 mb-1 cursor-pointer">
              <ion-icon name="logo-whatsapp" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">WhatsApp</ion-text>
          </div>

          <!-- Telegram -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('telegram', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-400 mb-1 cursor-pointer">
              <ion-icon name="paper-plane" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">Telegram</ion-text>
          </div>

          <!-- LinkedIn
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('linkedin', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-800 mb-1 cursor-pointer">
              <ion-icon name="logo-linkedin" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">LinkedIn</ion-text>
          </div> -->

          <!-- Native -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('native', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-black mb-1 cursor-pointer">
              <ion-icon name="share-social-outline" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">Native</ion-text>
          </div>
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
